export default __webpack_public_path__ + "static/media/awsIcon.946aa194.svg";